@use "../../scss/abstracts/utilities";

:host {
  --social-icon-button-size: #{utilities.toRem(24px)};
  --social-icon-padding: #{utilities.toRem(3px)};
  --social-icon-gap: #{utilities.toRem(8px)};
  --social-icon-bg: var(--sh_accent-primary);
  --social-icon-bg-hover: var(--sh_accent-secondary);
  display: inline-grid;
}

:host([variant="dark"]) {
  --social-icon-bg: var(--sh_fg-primary-inverted);
  --social-icon-bg-hover: color-mix(in srgb, var(--sh_fg-primary-inverted), #d9d9d9 16%);
}

:host([size="large"]) {
  --social-icon-button-size: #{utilities.toRem(30px)};
  --social-icon-padding: #{utilities.toRem(4px)};
}

.social-media-icons {
  display: flex;
  flex-wrap: wrap;
  gap: var(--social-icon-gap);
  margin: 0;
  padding: 0;
  list-style: none;
}

.social-media-icons > li {
  display: block;
  margin: 0;

  &:has(> .social-media-icons__link:not([href])) {
    display: none; // hide the entire icon if no URL is provided
  }
}

.social-media-icons__link {
  display: none;
  place-items: center;
  width: var(--social-icon-button-size);
  height: var(--social-icon-button-size);
  padding: var(--social-icon-padding);
  border-radius: 50%;
  background: var(--social-icon-bg);
  transition: background-color 0.2s ease;
  &[href] {
    display: grid; // only display the icon if a URL is provided
  }
}

.social-media-icons__link:hover,
.social-media-icons__link:focus-visible {
  background: var(--social-icon-bg-hover);
}

.social-media-icons__link > img {
  display: block;
  width: 100%;
  height: 100%;
}
